
import React, { useState } from 'react';
import { 
  Tabs, 
  TabsContent, 
  TabsList, 
  TabsTrigger 
} from '@/components/ui/tabs';
import { 
  Card, 
  CardContent 
} from '@/components/ui/card';
import {
  Award,
  Users,
  Heart,
  Lightbulb,
  TrendingUp
} from 'lucide-react';
import AIGrantMatchmaker from './AIGrantMatchmaker';
import CollaborativeFundingPools from './CollaborativeFundingPools';
import DirectArtistSupportHub from './DirectArtistSupportHub';
import AIFundingStrategist from './AIFundingStrategist';
import FundingOverview from './FundingOverview';

const ArtistFunding: React.FC = () => {
  const [activeTab, setActiveTab] = useState('overview');
  
  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <h2 className="text-3xl font-bold">Artist Funding</h2>
      </div>
      
      <Card className="border shadow-sm">
        <CardContent className="p-0">
          <Tabs 
            defaultValue="overview" 
            value={activeTab} 
            onValueChange={setActiveTab}
            className="w-full"
          >
            <TabsList className="grid grid-cols-5 bg-muted/50 p-1 rounded-none border-b h-auto">
              <TabsTrigger value="overview" className="data-[state=active]:bg-background rounded-none py-3">
                <div className="flex items-center gap-2">
                  <TrendingUp className="h-4 w-4" />
                  <span className="hidden md:inline">Funding Overview</span>
                </div>
              </TabsTrigger>
              <TabsTrigger value="grants" className="data-[state=active]:bg-background rounded-none py-3">
                <div className="flex items-center gap-2">
                  <Award className="h-4 w-4" />
                  <span className="hidden md:inline">Grant Matchmaker</span>
                </div>
              </TabsTrigger>
              <TabsTrigger value="collaborative" className="data-[state=active]:bg-background rounded-none py-3">
                <div className="flex items-center gap-2">
                  <Users className="h-4 w-4" />
                  <span className="hidden md:inline">Collaborative Funding</span>
                </div>
              </TabsTrigger>
              <TabsTrigger value="support" className="data-[state=active]:bg-background rounded-none py-3">
                <div className="flex items-center gap-2">
                  <Heart className="h-4 w-4" />
                  <span className="hidden md:inline">Direct Support</span>
                </div>
              </TabsTrigger>
              <TabsTrigger value="strategist" className="data-[state=active]:bg-background rounded-none py-3">
                <div className="flex items-center gap-2">
                  <Lightbulb className="h-4 w-4" />
                  <span className="hidden md:inline">Funding Strategist</span>
                </div>
              </TabsTrigger>
            </TabsList>
            
            <TabsContent value="overview" className="mt-0">
              <FundingOverview onTabChange={setActiveTab} />
            </TabsContent>
            
            <TabsContent value="grants" className="mt-0">
              <AIGrantMatchmaker />
            </TabsContent>
            
            <TabsContent value="collaborative" className="mt-0">
              <CollaborativeFundingPools />
            </TabsContent>
            
            <TabsContent value="support" className="mt-0">
              <DirectArtistSupportHub />
            </TabsContent>
            
            <TabsContent value="strategist" className="mt-0">
              <AIFundingStrategist />
            </TabsContent>
          </Tabs>
        </CardContent>
      </Card>
    </div>
  );
};

export default ArtistFunding;
